import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import { types } from "./actionTypes";
import { AxiosResponse } from "axios";
//medthods
import { getApi } from "../../helpers/auth_helpers";

// workers
function* workerDashboard({ callback, params }: any) {
  try {
    const query = new URLSearchParams();
    if (params?.createdAfter) {
      query.set("createdAfter", params.createdAfter);
    }
    if (params?.createdBefore) {
      query.set("createdBefore", params.createdBefore);
    }
    const suffix = query.toString() ? `?${query.toString()}` : "";
    const url: string =
      process.env.REACT_APP_SERVERURL + "/dashboard/dashboardwidgets" + suffix;

    const response: AxiosResponse = yield call(getApi, url);
    callback(response);
    yield put({
      type: types.GET_DASHBOARD_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
    // Always call back so the screen can leave its loading state.
    callback?.({ success: false, error: e });
  }
}
// watchers
export function* watchDashboard() {
  yield takeEvery(types.GET_DASHBOARD, workerDashboard);
}

function* dashboardSaga() {
  yield all([fork(watchDashboard)]);
}
export default dashboardSaga;
